import React, { useState } from 'react'
import { Box, } from '@mui/system'
import { Button, Divider, IconButton, Link, Modal, Paper, Typography } from '@mui/material'
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import ReactGA from 'react-ga4'

const Item = (props) => {

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const onClickDownload = () => {
    if (props.item.price === 0) {
      ReactGA.event({
        category: "bim-catalogs",
        action: `Downloaded: ${props.item.name}`,
        value: 0,
      });
      console.log(`Downloaded: ${props.item.name}`);
    } else {
      ReactGA.event({
        category: "bim-catalogs",
        action: `Added to Cart: ${props.item.name}`,
        value: props.item.price,
      });
      console.log(`Added to Cart: ${props.item.name}`);
    }
  }

  return (
    <Box>
      <Paper sx={{margin: 1, padding: 1,}} key={props.item.id}>
        <Box sx={{width: 230,}}>
          <Box sx={{alignItems: "center", display: "flex", justifyContent: "center", backgroundColor: "#f9f9f9", padding: 1,}}>
            <Box component="img" loading="lazy" src={props.item.imageURI} sx={{backgroundColor: "#eee", borderRadius: .5, height: 225, width: 225,}}></Box>
          </Box>
          <Divider sx={{marginY: 1,}}/>
          <Typography sx={{WebkitLineClamp: 3, height: 60,}}>{props.item.name}</Typography>
          <Box sx={{display: "flex", flexDirection: "row", alignItems: "center",}}>
            <Typography fontSize={12}>{props.item.price === 0 ? "Free Download" : "$" + parseFloat(props.item.price).toFixed(2) + " USD"}</Typography>
            <Box sx={{display: "flex", flex: 1, justifyContent: "flex-end",}}>
              <IconButton onClick={handleOpen} sx={{display: "flex", alignItems: "center", justifyContent: "center",}}>
                <InfoIcon/>
              </IconButton>
              <IconButton
                href={props.item.fileURI}
                onClick={() => {
                  onClickDownload();
                }}
              >
                {
                  props.item.price === 0 ? (
                    <CloudDownloadIcon />
                  ) : (
                    <AddShoppingCartIcon />
                  )
                }
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Paper>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{display: "flex", justifyContent: "center", alignItems: "center",}}
      >
        <Box sx={{backgroundColor: "#fff", borderRadius: 1, margin: 1, padding: .5, width: 500,}}>
          <Box sx={{alignItems: "center", display: "flex",}}>
            <Typography variant="h2" fontSize={16} sx={{marginLeft: .75,}}>Information</Typography>
            <Box sx={{alignItems: "center", display: "flex", justifyContent: "flex-end", flex: 1,}}>
              <IconButton onClick={handleClose}>
                <CloseIcon></CloseIcon>
              </IconButton>
            </Box>
          </Box>
          <Divider />
          <Box sx={{paddingX: 1, paddingBottom: 1, paddingTop: .5,}}>
            <Typography id="modal-modal-title" variant="h6" component="h3">
              {props.item.name}
            </Typography>
            <Typography id="modal-modal-description">
              {props.item.description}
            </Typography>
            <Typography fontSize={10}>File Type: {props.item.fileType}</Typography>
            <Typography fontSize={10}>Requires Version: {props.item.version}</Typography>
            <Link
              href={props.item.fileURI}
              onClick={() => {
                onClickDownload();
              }}
            >
              <Button variant="contained" sx={{width: "100%", marginTop: 2,}}>{props.item.price === 0 ? "Download" : "Purchase"}</Button>
            </Link>
          </Box>
        </Box>
      </Modal>
    </Box>
  )
}

export default Item